export enum Endpoint {
  adaptationInterventions = '/adaptation/interventions',
  adaptationInterventionFilters = '/adaptation/filters',
}
